module.exports = __webpack_public_path__ + "static/media/water-white.593de147.svg";